import React from 'react';
import Style from './About.module.scss';
import Avatar from '@mui/material/Avatar';


const About = () => {
  return (
    <div className="container">

      <section className={Style.hero}>
        <div>
          <h1>Before they sold out</h1>
          <p>Copper mug try-hard pitchfork pour-over freegan heirloom neutra air plant cold-pressed tacos poke beard tote bag. Heirloom echo park mlkshk tote bag selvage hot chicken authentic tumeric truffaut hexagon try-hard chambray.</p>
          <div>
            <button>Button</button>
            <button>Button</button>
          </div>
        </div>

        <div>
          <img alt="hero" src="https://dummyimage.com/720x600/edf2f7/a5afbd" />
        </div>
      </section>



      <section>
        <div>
          <h2>ROOF PARTY POLAROID</h2>
          <h1>Master Cleanse Reliac Heirloom</h1>
        </div>
        <div>
          <div>
            <h2>Shooting Stars</h2>
            <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
          </div>

          <div>
            <h2>Shooting Stars</h2>
            <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
          </div>

          <div>
            <h2>Shooting Stars</h2>
            <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
          </div>
        </div>
      </section>


      <section className={Style.hero}>
        <div>
          <img alt="hero" src="https://dummyimage.com/720x600/edf2f7/a5afbd" />
        </div>

        <div>
          <div>
            <h2>Shooting Stars</h2>
            <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
          </div>
          <div>
            <h2>Shooting Stars</h2>
            <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
          </div>
          <div>
            <h2>Shooting Stars</h2>
            <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
          </div>
        </div>
      </section>



      <section className={Style.our_team}>
        <div className={Style.member}>
          <h2>Our Team</h2>
          <p>Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them.</p>
        </div>
        <div className={Style.member_container}>
          <div className={Style.member_card}>
            <Avatar className={Style.avatar}>H</Avatar>
            <div>
              <h3>Santosh Panda</h3>
              <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
            </div>
          </div>

          <div className={Style.member_card}>
            <Avatar className={Style.avatar}>H</Avatar>
            <div>
              <h3>Shooting Stars</h3>
              <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
            </div>
          </div>

          <div className={Style.member_card}>
            <Avatar className={Style.avatar}>H</Avatar>
            <div>
              <h3>Shooting Stars</h3>
              <p>Blue bottle crucifix vinyl post-ironic four dollar toast vegan taxidermy. Gastropub indxgo juice poutine.</p>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default About;